/**
 * DOM utilities shared across the Otokoç widget kit.
 *
 * queryAllAcrossRoots pierces shadow-DOM boundaries so that the
 * kit can style and enhance elements rendered by the embedded chat frontend
 * inside its shadow root.
 */

export function queryAllAcrossRoots(selector: string): HTMLElement[] {
  const results: HTMLElement[] = [];
  const visited = new Set<ParentNode>();

  const visit = (root: ParentNode) => {
    if (visited.has(root)) return;
    visited.add(root);

    if ('querySelectorAll' in root) {
      for (const match of Array.from(root.querySelectorAll(selector))) {
        if (match instanceof HTMLElement) {
          results.push(match);
        }
      }
    }

    if (!('querySelectorAll' in root)) return;
    for (const node of Array.from(root.querySelectorAll('*'))) {
      if (node instanceof HTMLElement && node.shadowRoot) {
        visit(node.shadowRoot);
      }
    }
  };

  visit(document);
  return results;
}
